import React from 'react';

function SvgSofa() {
  return (
    <svg
        className="sofa meuble"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 262.9 223.28"
    >
      <defs>
        <style>
          {
            ".sofa_svg__sofa .sofa_svg__cls-2{fill:#f9f7f2}.sofa_svg__sofa .sofa_svg__cls-3{fill:#ede8df}.sofa_svg__sofa .sofa_svg__cls-4{fill:#fff}"
          }
        </style>
      </defs>
      <g
        id="sofa_svg__Calque_2"
        className="sofa_svg__sofa"
        data-name="Calque 2"
      >
        <g id="sofa_svg__Calque_1-2" data-name="Calque 1">
          <path
            className="sofa_svg__cls-1"
            d="M233.88 69a28.84 28.84 0 00-8.88 1.37A78.87 78.87 0 00146.85 0H128a78.86 78.86 0 00-78.27 71 29 29 0 10-19.43 54.7v76.91c0 11.37 8.58 20.67 19.06 20.67a17.45 17.45 0 003.24-.28 25.33 25.33 0 004.11.33h159.84a25.33 25.33 0 004.11-.33 17.47 17.47 0 003.25.33c10.47 0 19.05-9.3 19.05-20.67v-77A29 29 0 00233.88 69z"
            opacity={0.1}
          />
          <rect
            className="sofa_svg__cls-2"
            x={39.36}
            width={176.09}
            height={211.56}
            rx={78.59}
          />
          <rect
            className="sofa_svg__cls-3"
            x={32.19}
            y={117.6}
            width={94.64}
            height={37.08}
            rx={15.15}
          />
          <rect
            className="sofa_svg__cls-3"
            x={126.83}
            y={117.6}
            width={94.63}
            height={37.08}
            rx={15.15}
          />
          <rect
            className="sofa_svg__cls-4"
            x={20.3}
            y={153.19}
            width={212.65}
            height={70.09}
            rx={26.41}
          />
          <path
            className="sofa_svg__cls-4"
            d="M57.92 95.28A29 29 0 1020.3 125.7v76.91c0 11.37 8.58 20.67 19.06 20.67s19-9.3 19-20.67V99.84a22.12 22.12 0 00-.44-4.56z"
          />
          <path
            className="sofa_svg__cls-2"
            d="M43.15 98A14.13 14.13 0 1129 83.88 14.12 14.12 0 0143.15 98z"
          />
          <path
            className="sofa_svg__cls-4"
            d="M252.9 98a29 29 0 10-58.05 0v104.61c0 11.37 8.58 20.67 19.06 20.67S233 214 233 202.61v-77A29 29 0 00252.9 98z"
          />
          <path
            className="sofa_svg__cls-2"
            d="M238 98a14.12 14.12 0 11-14.12-14.13A14.12 14.12 0 01238 98z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgSofa;
